__turbopack_context__.v({
  "quiz-tab-item": "_6I_v-W_quiz-tab-item",
  "quiz-tab-item--focus-visible": "_6I_v-W_quiz-tab-item--focus-visible",
});
